import { Box, Tooltip, Icon } from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

import { THOR_COLORS } from '@/theme/thorTheme';

interface SimulationOverlayProps {
  onViewClick: () => void;
  show: boolean; // Only show in top-down mode
  x: number;
  y: number;
  object_name: string;
}

/**
 * Component that overlays clickable action buttons on top of the MuJoCo simulation.
 * Only visible in top-down camera mode.
 * Each button represents an action and is positioned at the robot's starting location.
 */
export function SimulationOverlay({
  onViewClick,
  show,
  x,
  y,
  object_name,
}: SimulationOverlayProps) {
  if (!show) {
    return null;
  }

  // const test = () => {
  //   console.log(`----------------- ${x} ${y}`)
  //   return null;
  // }

  // const position: any = getMujocoApp()?.getOverlayPosition(objectIndex) ;
  // console.log(`----------------- SimulationOverlay`);
  //   console.log(position);
  {
  }
  return (
    <Tooltip title={formatObjectName(object_name)} arrow>
      <Box
        onClick={() => {
          onViewClick();
        }}
        id={`overlay_${object_name}`}
        sx={{
          position: 'absolute',
          // left: `${position.x}%`,
          // top: `${position.y}%`,
          left: `${x}%`,
          top: `${y}%`,
          transform: 'translate(-50%, -50%)',
          width: 60,
          height: 60,
          borderRadius: '50%',
          backgroundColor: 'rgba(240, 82, 156, 0.5)',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'all', // Re-enable pointer events for the button
          '&:hover': {
            backgroundColor: 'rgba(240, 82, 156, 0.8)',
            transform: 'translate(-50%, -50%) scale(1.2)',
          },
        }}
      >
        <Icon
          component={RemoveRedEyeIcon}
          sx={{
            fontSize: 40,
            color: THOR_COLORS.cream,
          }}
        />
      </Box>
    </Tooltip>
  );
}

/**
 * Formats an object name from the action JSON into a readable label.
 * Example: "oven_588514d9b7194ff8509ced4f3f34adb0_1_0_0" -> "Oven"
 */
function formatObjectName(objectName: string): string {
  // Extract the object type (before the first underscore or hash)
  const parts = objectName.split('_');
  if (parts.length > 0 && parts[0]) {
    const objectType = parts[0];
    // Capitalize first letter
    return objectType.charAt(0).toUpperCase() + objectType.slice(1);
  }
  return objectName;
}
